module.exports = __webpack_public_path__ + "img/model-1@2x.5d89626.webp";